import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IDangKyAnImportRequest } from "../models/request/thuc-don/IDangKyAnImportRequest";
import { IFoDangKyAnHocSinh } from "../models/response/thuc-don/IFoDangKyAnHocSinh";
import { actions } from "../state/actions/actionsWrapper";
import { RootState } from "../state/reducers";

export const useDangKyAnHocSinh = () => {
    const dispatch = useDispatch();
    const {
        status,
        foDangKyAnHocSinhs,
        editingData,
        isShowEditModal,
        isShowImportModal,
        dangKyAnImports
    } = useSelector((x: RootState) => x.thucDonWrapper.dangKyAnHocSinh);

    const loadAllWithParams = useCallback((nam_hoc: string, dm_coso_id: number) => {
        dispatch(actions.thucDonWrapper.dangKyAnHocSinh.LOAD_BY_COSO_NAMHOC_START({
            nam_hoc,
            dm_coso_id
        }));
    }, [dispatch]);

    const save = useCallback((data: IFoDangKyAnHocSinh) => {
        dispatch(actions.thucDonWrapper.dangKyAnHocSinh.SAVE_START(data));
    }, [dispatch]);

    const deleteDk = useCallback((id: number) => {
        dispatch(actions.thucDonWrapper.dangKyAnHocSinh.DELETE_START(id));
    }, [dispatch]);

    const showEditModal = useCallback((data?: IFoDangKyAnHocSinh) => {
        dispatch(actions.thucDonWrapper.dangKyAnHocSinh.SHOW_EDIT_MODAL(data));
    }, [dispatch]);

    const closeEditModal = useCallback(() => {
        dispatch(actions.thucDonWrapper.dangKyAnHocSinh.CLOSE_EDIT_MODAL(undefined));
    }, [dispatch]);

    const showImportModal = useCallback(() => {
        dispatch(actions.thucDonWrapper.dangKyAnHocSinh.SHOW_IMPORT_MODAL(undefined));
    }, [dispatch]);

    const closeImportModal = useCallback(() => {
        dispatch(actions.thucDonWrapper.dangKyAnHocSinh.CLOSE_IMPORT_MODAL(undefined));
    }, [dispatch]);

    const importData = useCallback((data: IDangKyAnImportRequest) => {
        dispatch(actions.thucDonWrapper.dangKyAnHocSinh.SAVE_IMPORT_START(data));
    }, [dispatch]);

    return {
        status,
        foDangKyAnHocSinhs,
        editingData,
        isShowEditModal,
        isShowImportModal,
        dangKyAnImports,
        loadAllWithParams,
        save,
        deleteDk,
        showEditModal,
        closeEditModal,
        showImportModal,
        closeImportModal,
        importData
    };
};
